import { createSlice, configureStore } from "@reduxjs/toolkit";

const initialState = { contactIsOpen: false, formSubmitted: false }

const contactSlice = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        openContactForm(state) {
            state.contactIsOpen = true
        },
        closeContactForm(state) {
            state.contactIsOpen = false
        },
        submitForm(state) {
            state.formSubmitted = true
        }

    }
});

const reduxStore = configureStore({ reducer: contactSlice.reducer })

export const contactActions = contactSlice.actions;
export default reduxStore;


